export const capitalize = (word) => {
  const wordCapitlized = [...word];
  wordCapitlized[0] = word[0].toUpperCase();
  return wordCapitlized.join('');
};
